// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file blacklist.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { PickupLocation, PickupLocationJson } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { CustomTruckType, CustomTruckTypeJson } from "./truck_pb";
import { file_truck } from "./truck_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file blacklist.proto.
 */
export const file_blacklist: GenFile = /*@__PURE__*/
  fileDesc("Cg9ibGFja2xpc3QucHJvdG8SCXJhY2Nvb25haSLsAgoJQmxhY2tsaXN0EgoKAmlkGAEgAigEEjAKE3NlcnZpY2VfcHJvdmlkZXJfaWQYAiACKARSE3NlcnZpY2VfcHJvdmlkZXJfaWQSJAoNdHJ1Y2tfdHlwZV9pZBgDIAIoBFINdHJ1Y2tfdHlwZV9pZBIuChJwaWNrdXBfbG9jYXRpb25faWQYBCACKARSEnBpY2t1cF9sb2NhdGlvbl9pZBI6Cgp0cnVja190eXBlGAUgASgLMhoucmFjY29vbmFpLkN1c3RvbVRydWNrVHlwZVIKdHJ1Y2tfdHlwZRJDCg9waWNrdXBfbG9jYXRpb24YBiABKAsyGS5yYWNjb29uYWkuUGlja3VwTG9jYXRpb25SD3BpY2t1cF9sb2NhdGlvbhIOCgZyZWFzb24YByABKAkSOgoKY3JlYXRlZF9hdBhlIAIoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCmNyZWF0ZWRfYXQiqQEKD0JsYWNrbGlzdENyZWF0ZRIwChNzZXJ2aWNlX3Byb3ZpZGVyX2lkGAEgAigEUhNzZXJ2aWNlX3Byb3ZpZGVyX2lkEiQKDXRydWNrX3R5cGVfaWQYAiACKARSDXRydWNrX3R5cGVfaWQSLgoScGlja3VwX2xvY2F0aW9uX2lkGAMgAigEUhJwaWNrdXBfbG9jYXRpb25faWQSDgoGcmVhc29uGAQgASgJIqQBChRCbGFja2xpc3RMaXN0UmVxdWVzdBIyChRzZXJ2aWNlX3Byb3ZpZGVyX2lkcxgBIAMoBFIUc2VydmljZV9wcm92aWRlcl9pZHMSMAoTcGlja3VwX2xvY2F0aW9uX2lkcxgCIAMoBFITcGlja3VwX2xvY2F0aW9uX2lkcxImCg50cnVja190eXBlX2lkcxgDIAMoBFIOdHJ1Y2tfdHlwZV9pZHMiOQoNQmxhY2tsaXN0TGlzdBIoCgpibGFja2xpc3RzGAEgAygLMhQucmFjY29vbmFpLkJsYWNrbGlzdEIGWgQuL3Bi", [file_google_protobuf_timestamp, file_pickup_location, file_truck]);

/**
 * @generated from message raccoonai.Blacklist
 */
export type Blacklist = Message<"raccoonai.Blacklist"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required uint64 truck_type_id = 3 [json_name = "truck_type_id"];
   */
  truckTypeId: bigint;

  /**
   * @generated from field: required uint64 pickup_location_id = 4 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional raccoonai.CustomTruckType truck_type = 5 [json_name = "truck_type"];
   */
  truckType?: CustomTruckType;

  /**
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 6 [json_name = "pickup_location"];
   */
  pickupLocation?: PickupLocation;

  /**
   * @generated from field: optional string reason = 7;
   */
  reason: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;
};

/**
 * @generated from message raccoonai.Blacklist
 */
export type BlacklistJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required uint64 truck_type_id = 3 [json_name = "truck_type_id"];
   */
  truck_type_id?: string;

  /**
   * @generated from field: required uint64 pickup_location_id = 4 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional raccoonai.CustomTruckType truck_type = 5 [json_name = "truck_type"];
   */
  truck_type?: CustomTruckTypeJson;

  /**
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 6 [json_name = "pickup_location"];
   */
  pickup_location?: PickupLocationJson;

  /**
   * @generated from field: optional string reason = 7;
   */
  reason?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.Blacklist.
 * Use `create(BlacklistSchema)` to create a new message.
 */
export const BlacklistSchema: GenMessage<Blacklist, {jsonType: BlacklistJson}> = /*@__PURE__*/
  messageDesc(file_blacklist, 0);

/**
 * @generated from message raccoonai.BlacklistCreate
 */
export type BlacklistCreate = Message<"raccoonai.BlacklistCreate"> & {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required uint64 truck_type_id = 2 [json_name = "truck_type_id"];
   */
  truckTypeId: bigint;

  /**
   * @generated from field: required uint64 pickup_location_id = 3 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message raccoonai.BlacklistCreate
 */
export type BlacklistCreateJson = {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required uint64 truck_type_id = 2 [json_name = "truck_type_id"];
   */
  truck_type_id?: string;

  /**
   * @generated from field: required uint64 pickup_location_id = 3 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message raccoonai.BlacklistCreate.
 * Use `create(BlacklistCreateSchema)` to create a new message.
 */
export const BlacklistCreateSchema: GenMessage<BlacklistCreate, {jsonType: BlacklistCreateJson}> = /*@__PURE__*/
  messageDesc(file_blacklist, 1);

/**
 * @generated from message raccoonai.BlacklistListRequest
 */
export type BlacklistListRequest = Message<"raccoonai.BlacklistListRequest"> & {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 2 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * filter by custom truck type
   *
   * @generated from field: repeated uint64 truck_type_ids = 3 [json_name = "truck_type_ids"];
   */
  truckTypeIds: bigint[];
};

/**
 * @generated from message raccoonai.BlacklistListRequest
 */
export type BlacklistListRequestJson = {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 2 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * filter by custom truck type
   *
   * @generated from field: repeated uint64 truck_type_ids = 3 [json_name = "truck_type_ids"];
   */
  truck_type_ids?: string[];
};

/**
 * Describes the message raccoonai.BlacklistListRequest.
 * Use `create(BlacklistListRequestSchema)` to create a new message.
 */
export const BlacklistListRequestSchema: GenMessage<BlacklistListRequest, {jsonType: BlacklistListRequestJson}> = /*@__PURE__*/
  messageDesc(file_blacklist, 2);

/**
 * @generated from message raccoonai.BlacklistList
 */
export type BlacklistList = Message<"raccoonai.BlacklistList"> & {
  /**
   * @generated from field: repeated raccoonai.Blacklist blacklists = 1;
   */
  blacklists: Blacklist[];
};

/**
 * @generated from message raccoonai.BlacklistList
 */
export type BlacklistListJson = {
  /**
   * @generated from field: repeated raccoonai.Blacklist blacklists = 1;
   */
  blacklists?: BlacklistJson[];
};

/**
 * Describes the message raccoonai.BlacklistList.
 * Use `create(BlacklistListSchema)` to create a new message.
 */
export const BlacklistListSchema: GenMessage<BlacklistList, {jsonType: BlacklistListJson}> = /*@__PURE__*/
  messageDesc(file_blacklist, 3);

